import { PaymentInitResponse } from "../api/PaymentInitResponse";
import { BookingSummary } from "./store/BookingSummary";

export class PaymentInitResult {
	merchantKey: string;
	booking: BookingSummary;

	constructor(resp: PaymentInitResponse) {
		this.merchantKey = resp.merchantKey;
		this.booking = new BookingSummary(resp.booking);	
	}
}